var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSecurityOff = function SvgSecurityOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47 7.72a.75.75 0 0 1 1.06 0L12 10.19l2.47-2.47a.75.75 0 1 1 1.06 1.06l-2.47 2.47 2.47 2.47a.75.75 0 1 1-1.06 1.06L12 12.31l-2.47 2.47a.75.75 0 0 1-1.06-1.06l2.47-2.47-2.47-2.47a.75.75 0 0 1 0-1.06Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.408 1.633a2.25 2.25 0 0 1 1.184 0l6.75 1.841A2.25 2.25 0 0 1 21 5.645v10.031a2.25 2.25 0 0 1-1.042 1.898l-6.75 4.296a2.25 2.25 0 0 1-2.416 0l-6.75-4.296A2.25 2.25 0 0 1 3 15.676V5.646a2.25 2.25 0 0 1 1.658-2.172l6.75-1.84Zm.79 1.448a.75.75 0 0 0-.395 0l-6.75 1.84a.75.75 0 0 0-.553.724v10.031a.75.75 0 0 0 .347.633l6.75 4.295a.75.75 0 0 0 .806 0l6.75-4.295a.75.75 0 0 0 .347-.633V5.646a.75.75 0 0 0-.553-.724l-6.75-1.841Z"
  })));
};

export default SvgSecurityOff;